import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { showsPurchasedEntityModel } from '~/entities/shows/purchased'

export const loadGridPurchasedTvShows = createEvent()

sample({
  clock: loadGridPurchasedTvShows,
  filter: not(api.tvshows.getPurchasedTvShowsGridFx.pending),
  target: api.tvshows.getPurchasedTvShowsGridFx,
})

export const $isGridPurchasedTvShowsLoading = combine(
  {
    purchasedTvShowsLoading: api.tvshows.getPurchasedTvShowsGridFx.pending,
    purchasedTvShows: showsPurchasedEntityModel.$purchasedTvShowsGrid,
  },
  ({ purchasedTvShowsLoading, purchasedTvShows }) =>
    !purchasedTvShows && purchasedTvShowsLoading
)

export const loadMoreGridPurchasedTvShows = createEvent()

sample({
  clock: loadMoreGridPurchasedTvShows,
  filter: not(api.tvshows.getPurchasedTvShowsGridFx.pending),
  fn: () => null,
  target: showsPurchasedEntityModel.loadMorePurchasedTvShowsGrid,
})
